import api from "./Api";

export default class BatchService {
  postEnviarBatch(file, callback) {
    const formData = new FormData();
    formData.append("file", file);

    api
      .post(this.host() + "/api/v1/batch", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        callback(null, response.data);
      })
      .catch((erro) => {
        callback(erro, null);
      });
  }

  // Listagem de arquivos NFE Stockfy
  getListarArquivosNfe(callback) {
    api
      .get(this.host() + "/api/v1/stockfy/nfe")
      .then((response) => {
        callback(null, response.data);
      })
      .catch((erro) => {
        callback(erro, null);
      });
  }

  // Envio de planilha de NFE Stockfy
  postEnviarBatchNfe(file, callback) {
    const formData = new FormData();
    formData.append("file", file);

    api
      .post(this.host() + "/api/v1/stockfy/nfe", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        callback(null, response.data);
      })
      .catch((erro) => {
        callback(erro, null);
      });
  }
  host() {
    return process.env.REACT_APP_HOST_API;
  }
}
